module.exports = __webpack_public_path__ + "static/media/visitor_logo.19f5ee3d.png";